import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import CustomSwitch from "../utilities/CustomSwitch";
import HomeIcon from "../images/homeicon.svg";
import { useNavigate } from 'react-router-dom';
function Navbar() {
  var location = useLocation();
  var isUserManagement = location.pathname.includes('/user-management')
  var isEmailPage = location.pathname.includes("emailTemplate");
  var isEmailDetailsPage = location.pathname.includes("emailDetails");
  var isEmailNewTemplatePage = location.pathname.includes("emailNewTemplate");
  var isAnniversaryPage = location.pathname.includes("anniversaryReport");

  const navigate = useNavigate();

  return (
    <div className="container-fluid">
      <div className="menu-card-container">
        <nav className="navbar navbar-expand-lg navbar-light custom nav-underline custom-nav-link">
          <div className="container-fluid d-flex justify-content-between w-100">
            <div className="d-flex align-items-center">
                <img
                  src={HomeIcon}
                  width={16}
                  height={17}
                  className="d-inline-block align-top"
                  onClick={() => navigate("/AppAdmin")}
                  alt="Home Icon"
                />
            </div>

            <div className="collapse navbar-collapse d-flex justify-content-between" id="navbarTogglerDemo02">
              <ul className="navbar-nav me-auto mt-2 mt-lg-0">
                <li className="nav-item">
                    <NavLink
                    end
                    className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                    to="/dashboard"
                    >
                    Dashboard
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink
                    end
                    className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                    to="/eventReport"
                    >
                    Reports
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" to="/user-management">
                    User Management
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" to="/site-management">
                    Site Management
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" to="/emailTemplate">
                    Email Template
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" to="/AppSettings">
                    App settings
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink className="nav-link" to="/Feedbacks">
                    Feedback
                    </NavLink>
                </li>
                </ul>
            </div>

            {/* Right Section: Custom Switch */}
            {!isAnniversaryPage &&
                !isUserManagement &&
                !isEmailPage &&
                !isEmailDetailsPage &&
                !isEmailNewTemplatePage && (
                <div className="ms-auto d-flex align-items-center">
                    <CustomSwitch id="navBarMltValue" />
                    <span
                    className="nav-link disabled"
                    style={{ marginRight: "3px", marginLeft: "7px", fontSize: "5px" }}
                    >
                    MLT
                    </span>
                </div>
                )}
  </div>
</nav>
      </div>
    </div>
  );
}

export default Navbar;
